import React from "react";
import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import { GetQuestionList } from "app/components/tools/politicalMonitorConfigTool/assets/widgetInitUtils";
import { DUMMY_CURRENT_QUESTIONS_LIST } from "app/components/tools/politicalMonitorConfigTool/assets/constants";
import DisplayImage from "./image.png";

const description =
  "The ‘Resolve Political Monitor’ (RPM) widget displays a single topic question into your story.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Political Monitor",
  id: "political-monitor",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/2021/political-monitor/index.html?resizable=true",

  // ConfigComponent: Loadable({
  //   delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
  //   loader: () =>
  //     import(/* webpackChunkName: "politicalMonitorConfigTool" */ "app/components/tools/politicalMonitorConfigTool/politicalMonitorConfigTool"),
  //   loading: DynamicImportLoader,
  //   modules: ["politicalMonitorConfigTool"]
  // })

  ConfigComponent: Loadable.Map({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: {
      ConfigComponent: () =>
        import("app/components/tools/politicalMonitorConfigTool/politicalMonitorConfigTool"),
      questionLists: () => {
        return GetQuestionList("data.json", DUMMY_CURRENT_QUESTIONS_LIST).then(
          d => d
        );
      }
    },
    loading: DynamicImportLoader,
    timeout: 10000, // 10 seconds
    modules: ["politicalMonitorConfigTool"],
    render(loaded, props) {
      let ConfigComponent = loaded.ConfigComponent.default;
      let questionLists = loaded.questionLists;
      const _props = { ...props, questionLists };
      return <ConfigComponent {..._props} questionLists={questionLists} />;
    }
  })
};

export default CONFIG;
